import common from "../common";

export default class PowerUp extends PIXI.Container
{
    constructor(type)
    {
        super();

        this.type = type;
        this.active = false;

        this.collected = false;

        this.targetY = null;
        this.boxSize = 40;
        this.hitSize = 180;
        this.hitBox = {x:-this.hitSize/2, y:-this.boxSize/2, width:this.hitSize, height:this.boxSize}

        this.bounds = {x:-this.boxSize/2, y:-this.boxSize/2, width:this.boxSize, height:this.boxSize};

        this.icon = null;
        this.shadow = null;

        this.highlightTween = null;

        this.particle = null;

        this.init();
    }

    init()
    {
        this.shadow = common.display.sprite({asset:'food_shadow', visible:false, alpha:0.5, scaleX:0.7, scaleY:0.5, anchor:0.5, parent:this});

        this.icon = common.display.sprite({asset:common.config.weapons.weapons[this.type].image, anchor:0.5, scale:common.config.settings.gamePhysics.powerUp.imageScale, parent:this});

        this.shadow.y = this.icon.height * 0.2;

        this.highlightTween = new TimelineMax({repeat:-1, onUpdate: () => {
            this.shadow.alpha = 0.3 + (0.5-(this.icon.anchor.y-0.5));
        }});
        this.highlightTween.to(this.icon.anchor, 0.3, {y:1, ease:Sine.easeOut});
        this.highlightTween.to(this.icon.anchor, 0.7, {y:0.5, ease:Bounce.easeOut});
        /*
        var colour = 0xFFFFFF;

        if(this.type == 'sweets')
            colour = 0xeb0976;
        else if(this.type == 'yoghurt')
            colour = 0xdc9cf7;
        else if(this.type == 'banana')
            colour = 0xf5db16;

        common.display.rectangle({fillColour:colour, rect:this.bounds, parent:this});
        common.display.rectangle({lineColour:colour, rect:this.hitBox, parent:this});*/
    }

    destroy()
    { 
        
    }

    throwIn(targetX, targetY, onLanded)
    {
        this.targetY = targetY;
        this.x = common.STAGE_HALF_WIDTH + (Math.random() > 0.5 ? P3.View.width/2 : -P3.View.width/2);
        this.y = common.STAGE_HEIGHT * Math.random();

        var midX = this.x + ((targetX - this.x)/2);
        var midY = this.y + ((targetY - this.y)/2) - 100;

        TweenMax.to(this, 0.8, {bezier:[{x:midX, y:midY}, {x:targetX, y:targetY}], ease:Linear.easeNone, onComplete:() => {
            this.active = true;
            onLanded();
            this.shadow.visible = true;
        }});

        common.audio.playSound(["sfx_powerup_arrive_00", "sfx_powerup_arrive_01"]);
    }

    collect(targetX, targetY, onComplete)
    {
        this.shadow.visible = false;
        this.highlightTween.stop();
        this.active = false;
        TweenMax.to(this, 0.3, {bezier:[{x:this.x - ((this.x - targetX) / 2), y:this.y - 50}, {x:targetX, y:targetY}], ease:Sine.easeIn, onComplete:onComplete})
        if(this.particle) this.particle.emit = false;
    }
}